import React from 'react';
import { Navigate } from 'react-router-dom';
import TabbedPage from 'components/tabbed-page';
import { useCurrentRoles } from 'hooks/use-current-roles';
import LeaveRequestManager from 'pages/leave-request-manager';
import LeaveTypeManager from 'pages/leave-type-manager';
import LiveShowManager from 'pages/liveshows-manager';
import GroupLiveShowManager from 'pages/group-live-show-manager';
import LiveSupportManager from 'pages/live-support-manager';
import PKManager from 'pages/pk-manager';
import CountryManager from 'pages/country-manager';
import BannerManager from 'pages/banners-manager';
import OutStandingManager from 'pages/outstanding-manager';
import StoreManager from 'pages/store-manager';
import NotificationManager from 'pages/notification-manager';
import JobNotificationManager from 'pages/job-notification';

/**
 * Các trang "anh em" trước đây nằm rải rác ở nhiều menu, nay gộp thành một trang có tab.
 * Trang cũ giữ nguyên code; đường dẫn cũ chuyển tới đúng tab (xem routes.tsx).
 */

export const LeavePage = () => (
  <TabbedPage
    tabs={[
      { key: 'requests', label: 'Đơn nghỉ phép', render: () => <LeaveRequestManager /> },
      { key: 'types', label: 'Loại nghỉ phép', render: () => <LeaveTypeManager /> },
    ]}
  />
);

export const LiveShowPage = () => (
  <TabbedPage
    tabs={[
      { key: 'rooms', label: 'Phòng live', render: () => <LiveShowManager /> },
       { key: 'groups', label: 'Nhóm liveshow', render: () => <GroupLiveShowManager /> },
       { key: 'support', label: 'Gọi KTV cho NPC', render: () => <LiveSupportManager /> },
    ]}
  />
);

export const PkPage = () => (
  <TabbedPage
    tabs={[
      { key: 'matches', label: 'Trận PK', render: () => <PKManager /> },
      { key: 'countries', label: 'Quốc gia', render: () => <CountryManager /> },
    ]}
  />
);

export const MediaLinksPage = () => {
  const { isAdmin } = useCurrentRoles();
  return (
    <TabbedPage
      tabs={[
        { key: 'banners', label: 'Banner', render: () => <BannerManager /> },
        // API danh sách Tin nổi bật chỉ cho ADMIN.
        {
          key: 'outstanding',
          label: 'Tin nổi bật',
          render: () => <OutStandingManager />,
          hidden: !isAdmin,
        },
        { key: 'store', label: 'HP Store', render: () => <StoreManager /> },
      ]}
    />
  );
};

export const NotificationsPage = () => (
  <TabbedPage
    tabs={[
      { key: 'push', label: 'Thông báo đẩy', render: () => <NotificationManager /> },
      { key: 'group', label: 'Tin nhắn nhóm tự động', render: () => <JobNotificationManager /> },
    ]}
  />
);

/** Đường dẫn cũ → trang gộp đúng tab (giữ bookmark, link trong tài liệu cũ). */
export const redirectTo = (to: string) => {
  const RedirectRoute = () => <Navigate to={to} replace />;
  return RedirectRoute;
};
